import styled from 'styled-components';

export const Wrap = styled.div`
  position: relative;

  .answer-btn {
    cursor: pointer;
    position: sticky;
    bottom: 12vh;
    left: 80%;
  }
`;

export const VideoWrap = styled.div`
  width: 100%;
  padding-top: ${({ width, height }) => `${(height / width) * 100}%`};
  border-top: none;
  border-bottom: none;
  box-sizing: border-box;
  background: transparent;
  background-size: cover;
  position: relative;

  > video {
    object-fit: cover;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }

  > img {
    width: 100%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`;

export const BGWrap = styled.div`
  width: 100%;
  padding-top: ${({ width, height }) => `${(height / width) * 100}%`};
  border-top: none;
  border-bottom: none;
  box-sizing: border-box;
  background: url(${({ imgUrl }) => imgUrl}) center center no-repeat;
  background-size: cover;
  position: relative;

  > button {
    width: 10%;
    height: 5%;
    border: 0;
    background: transparent;
    position: absolute;
  }

  .outter {
    top: 72%;
    left: 21%;
  }

  .inner {
    top: 72%;
    left: 45%;
  }

  .complex {
    top: 72%;
    left: 69%;
  }
`;

export const Overlay = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  position: fixed;
  top: 0;
  left: 0;
`;

export const Modal = styled.div`
  width: 50%;
  height: 60vh;
  padding: 80px 40px 40px;
  background-color: #FFFFFF;
  position: relative;

  > div.box {
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 100%;

    > h2 {
      line-height: 36px;
      color: #292c3c;
      font-size: 30px;
      font-weight: 700;
    }

    > p {
      margin-top: 24px;
      margin-bottom: 32px;
      line-height: 32px;
      color: #000000;
      font-size: 18px;
    }

    > div.img-box {
      height: 100%;
      text-align: center;
      overflow-y: auto;

      > img {
        width: 80%;
        cursor: pointer;

        & + img {
          margin-top: 32px;
        }
      }
    }

    iframe {
      border-radius: 30px;
    }
  }
`;

export const Close = styled.button`
  width: 72px;
  height: 72px;
  background-color: #EDEDED;
  border: 0;
  position: absolute;
  top: 0;
  right: 0;

  &:before,
  &:after {
    content: ' ';
    width: 2px;
    height: 40px;
    background-color: #BBB;
    position: absolute;
    top: 18px;
    left: 50%;
    transform: translateX(-50%);
  }

  &:before {
    transform: rotate(45deg);
  }

  &:after {
    transform: rotate(-45deg);
  }
`;
